////////LIBRARY/////////
import React from 'react'
///////COMPONENTS///////
import { TableLineWrapper } from '../../../../theme/GlobalCss'

const TableRows = ({ children, error = false }) => {
	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TableLineWrapper error={error} height="50">
			{children}
		</TableLineWrapper>
	)
}

TableRows.propTypes = {}

TableRows.defaultPropTypes = {}

export default TableRows
